import { Question } from '../../../types';
import { EditableListItem, AddItemInput, TagsField } from '../../components';
import { useQuestionColumns } from '../../hooks';
import { Droppable, Draggable } from 'react-beautiful-dnd';

interface TableQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function TableQuestionConfig({ question, onEdit }: TableQuestionConfigProps) {
  const {
    newColumn,
    isAddingColumn,
    setNewColumn,
    setIsAddingColumn,
    addColumn,
    cancelAddColumn,
    removeColumn,
    updateColumn,
  } = useQuestionColumns({ question, onEdit });

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-600">
        Colunas
      </label>

      <Droppable droppableId={`question-${question.id}-columns`} type="column">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="space-y-2"
          >
            {(question.columns || []).map((column, idx) => (
              <Draggable
                key={`column-${idx}`}
                draggableId={`column-${question.id}-${idx}`}
                index={idx}
              >
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} {...provided.draggableProps}>
                    <EditableListItem
                      value={column}
                      onChange={(value) => updateColumn(idx, value)}
                      onRemove={() => removeColumn(idx)}
                      dragHandleProps={provided.dragHandleProps}
                      isDragging={snapshot.isDragging}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <AddItemInput
        value={newColumn}
        onChange={setNewColumn}
        onAdd={addColumn}
        onCancel={cancelAddColumn}
        onToggle={() => setIsAddingColumn(true)}
        placeholder="Nome da coluna"
        buttonLabel="Adicionar coluna"
        isVisible={isAddingColumn}
      />

      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
